import Vue from 'vue'
import tinymce from 'tinymce'
import VueTinymce from "@packy-tang/vue-tinymce"
Vue.prototype.$tinymce = tinymce
Vue.use(VueTinymce)